import React, { useContext, useRef } from 'react'

import { CloseButton, CloseContainer, CompanyDataContainer, ModalText, WrapperContainer } from './styled'
import { Icon, ModalContainer, ModalContent, Overlay, Title } from 'ui/styled'

import { CoreContext } from 'context/CoreContext'

export default function Wrapper({ children, title, text, onClose, modalWidth, stickyHeader = false, viewportSpacing = false, belowHeader = false }) {

  const { setModal } = useContext(CoreContext)
  const contentRef = useRef(null)

  const close = async () => {
    try {
      if (typeof onClose === 'function') {
        await onClose()
      }
    } finally {
      setModal(null);
    }
  }

  const handleClose = (e) => {
    if (e.currentTarget.contains(e.target) && !contentRef.current?.contains(e.target)) {
      close()
    }
  }

  return (
    <>
      <Overlay onClick={handleClose} $belowHeader={belowHeader}>
        <ModalContainer $viewportSpacing={viewportSpacing} $belowHeader={belowHeader}>
          <ModalContent ref={contentRef} id="modal-content" role="dialog" aria-modal="true" aria-label={title} $width={modalWidth} $viewportSpacing={viewportSpacing} $belowHeader={belowHeader}>
            <CompanyDataContainer>
              <CloseContainer >
                <WrapperContainer>
                  <Title nomargin>{title}</Title>
                  <ModalText>{text}</ModalText>
                </WrapperContainer>
                <CloseButton onClick={close} aria-label="Close modal">
                  <Icon icon={'close-big-white'} pointer={true} width={'22px'} height='22px' />
                </CloseButton>
              </CloseContainer>
              {children}
            </CompanyDataContainer>
          </ModalContent>
        </ModalContainer>
      </Overlay>
    </>
  )
}
